export default {
  leadingZero(num) {
    if (num < 10) {
      return `0${num}`;
    }
    return String(num);
  },

  formatDate(dateObj) {
    return `${this.leadingZero(dateObj.getDate())}/${this.leadingZero(
      dateObj.getMonth() + 1
    )}/${dateObj.getFullYear()}`;
  },

  formatDateToParameter(dateObj) {
    return `${dateObj.getFullYear()}-${this.leadingZero(
      dateObj.getMonth() + 1
    )}-${this.leadingZero(dateObj.getDate())}`;
  },

  formatDateToUtcIsoAt3(dateObj) {
    const utc = new Date(
      Date.UTC(
        dateObj.getFullYear(),
        dateObj.getMonth(),
        dateObj.getDate(),
        3,
        0,
        0,
        0
      )
    );
    return utc.toISOString();
  },

  formatDateStringToParameter(dateStr) {
    const matches = dateStr.match(/(\d{2})(\d{2})(\d{4})/);
    if (matches) {
      return `${matches[3]}-${matches[2]}-${matches[1]}`;
    }
    return dateStr;
  },

  formatDateStringToUtcIsoAt3(dateStr) {
    if (!dateStr) return dateStr;

    const s = String(dateStr).trim();
    const ddmmyyyy = s.match(/(\d{2})\D?(\d{2})\D?(\d{4})/);
    if (ddmmyyyy) {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      d.setFullYear(Number(ddmmyyyy[3]));
      d.setMonth(Number(ddmmyyyy[2]) - 1);
      d.setDate(Number(ddmmyyyy[1]));
      return this.formatDateToUtcIsoAt3(d);
    }

    const yyyymmdd = s.match(/(\d{4})\D?(\d{2})\D?(\d{2})/);
    if (yyyymmdd) {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      d.setFullYear(Number(yyyymmdd[1]));
      d.setMonth(Number(yyyymmdd[2]) - 1);
      d.setDate(Number(yyyymmdd[3]));
      return this.formatDateToUtcIsoAt3(d);
    }

    const parsed = new Date(s);
    if (!Number.isNaN(parsed.getTime())) {
      return this.formatDateToUtcIsoAt3(parsed);
    }

    return dateStr;
  },

  formatDocument(value) {
    const matches = value.match(/(\d{3})(\d{3})(\d{3})(\d{2})/);
    if (matches) {
      return `${matches[1]}.${matches[2]}.${matches[3]}-${matches[4]}`;
    }
    return value;
  },

  formatZip(digits) {
    const matches = digits.match(/(\d{5})(\d{3})/);
    if (matches) {
      return `${matches[1]}-${matches[2]}`;
    }
    return digits;
  },

  formatPhone(digits) {
    const matches = digits.match(/(\d{2})(\d{4,6})(\d{4})/);
    if (matches) {
      return `(${matches[1]}) ${matches[2]} ${matches[3]}`;
    }
    return digits;
  },

  formatNumber(value, fractionDigits, fractionSeparator) {
    const num = Number(value).toFixed(fractionDigits || 0);
    return String(num).replace('.', fractionSeparator || '.');
  },

  formatCurrency(value, currency = 'R$') {
    const formattedCurrency = this.formatNumber(value || 0, 2, ',');
    return `${currency} ${formattedCurrency}`;
  },

  formatTimeDuration(value) {
    // Value must be in minutes.
    if (value > 60) {
      const h = Math.floor(value / 60);
      const m = Math.max(0, Math.floor(value - h * 60));
      let ret = `${h} h`;
      if (m) {
        ret += ` ${m} min`;
      }
      return ret;
    }
    return `${value} min`;
  }
};
